import { render } from "./StartProcessButtonComponent.vue?vue&type=template&id=8076c68c&scoped=true"
import script from "./StartProcessButtonComponent.vue?vue&type=script&lang=js"
export * from "./StartProcessButtonComponent.vue?vue&type=script&lang=js"

import "./StartProcessButtonComponent.vue?vue&type=style&index=0&id=8076c68c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8076c68c"]])

export default __exports__